'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import 'angular-socket-io';
import ngMask from 'angular-ui-mask';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
// import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';


import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import physician from './physician';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import statCard from '../components/stat-card/stat-card.directive';
import './app.scss';

angular.module('safestartServerApp', [ngCookies, ngResource, ngSanitize, ngMask, 'btford.socket-io',
  uiRouter, uiBootstrap, _Auth, account, admin, navbar, footer, main, constants, socket, util, statCard, physician
])
  .config(routeConfig)
  .directive('lightgalleryMultiple', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      if (scope.$last) {

        // ng-repeat is completed
        element.parent().lightGallery();
      }
    }
  };
})
  .directive('lightgallerySingle', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
          // for a single element
          element.lightGallery();
      }
    };
  })
  .directive('datepicker', function() {
    return {
      require: 'ngModel',
      link: function(scope, el, attr, ngModel) {
        $(el).datepicker({
          dateFormat: 'mm/dd/yy',
          onSelect: function(dateText) {
            scope.$apply(function() {
              ngModel.$setViewValue(dateText);
            });
          }
        });
      }
    };
  })
  .filter('trusted', ['$sce', function($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url);
    };
  }])
  .run(function($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['safestartServerApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js